
const actions = {
  setTest1({ commit }, data )  {
    commit('SET_TEST1', data)
  },
  setThemeBar({ commit }, data) {
    if (typeof data === 'boolean') {
      commit('THEME_BAR', data)
    }
  },
  setUploading({ commit }, data) {
    if (typeof data === 'boolean') {
      commit('UPLOADING', data)
    }
  },
  setProgressMsg({ commit }, data) {
      commit('PROGRESSMSG', data)
  },
  setPercentageUploaded({ commit }, data) {
    if (typeof data === 'number') {
      commit('PERCENTAGE_UPLOADED', data)
    }
  },
  resetSplitButtonLocation({ commit, getters }) {
    let a = getters.getSplitButtonLocationReset
    if (typeof a === 'number') {
      commit('RESET_SPLIT_BUTTON_LOCATION', a + 1)
    } else {
      commit('RESET_SPLIT_BUTTON_LOCATION', 0)
    }
  },
  setErrorMessage({ commit }, data) {
    if (Array.isArray(data)) {
      commit('ERROR_MESSAGES', data)
    }
  },
  removeErrorMessage({ commit, getters }, data) { // untested
    let a = getters.getErrorMessages
    // 
    if (Array.isArray(a)) {
      let c = a.findIndex(d => d.content === data.content && d.severity === data.severity)
      a.splice(c, 1)
      commit('ERROR_MESSAGES', a)
    } else {
      commit('ERROR_MESSAGES', [])
    }
  },
  addErrorMessage({ commit, getters }, data) {
    if (data && data.severity && data.content) {
      let a = getters.getErrorMessages
      let e = a.findIndex(f => f.content === data.content && f.severity === data.severity)
      if (e < 0) { // if not present already
        if (Array.isArray(a)) {
          // if error message has life then it will remove itself, just uncomment the code
          // data.life = 4000 + (1500 * a.length) // first's life is 4sec, for 2nd it is 5sec, then 6sec and so on...

          a.push(data)
          commit('ERROR_MESSAGES', a)
          // setTimeout(() => {
          //   let b = getters.getErrorMessages
          //   // 
          //   // b.forEach(g => 
          //   if (b && b[0]) {
          //     let c = b.findIndex(d => d.content === data.content && d.severity === data.severity)
          //     b.splice(c, 1)
          //     // 
          //     // b.forEach(g => 
          //     commit('ERROR_MESSAGES', b)
          //   } else {
          //     commit('ERROR_MESSAGES', [])
          //   }
          // }, data.life)
        } else {
          commit('ERROR_MESSAGES', [data])
        }
      }
    }
  },
  setReLoginDialog({ commit }, data) {
    if (typeof data === 'boolean') {
      commit('RELOGIN_DIALOG', data)
    }
  },
  setLastPage({ commit }, data) {
    if (typeof data === 'string') {
      commit('LAST_PAGE', data)
    }
  },
  setLastFromPage({ commit }, data) {
    if (typeof data === 'string') {
      commit('LAST_FROM_PAGE', data)
    }
  },
  setLastPathName({ commit }, data) {
    if (typeof data === 'string') {
      commit('LAST_PATH_NAME', data)
    }
  },
  removeEP({ commit, getters }, data) {
    // 
    if (typeof data === 'object' && data.url && data.method) {
      let a = getters.getLastEPs
      // 
      let b = a.findIndex(c => {
        if (c.url === data.url && c.method === data.method) {
          if (data.body && c.body === data.body) {
            return true
          } else if (data.body && c.body !== data.body) {
            return false
          } else {
            return true
          }
        } else {
          return false
        }
      })
      // 
      if (b >= 0) {
        // 
        a.splice(b, 1)
        commit('LAST_EPs', a)
      }
    }
  },
  addLastEP({ commit, getters }, data) {
    if (
      typeof data === 'object' && 
      data.url && 
      data.method && 
      data.url !== "https://securetoken.googleapis.com/v1/token?key=AIzaSyDiQ65WBJJhhWE4kxjEzeIMV66VT25eaFw"
    ) {
      let a = getters.getLastEPs
      if (Array.isArray(a)) {
        a.push(data)
        commit('LAST_EPs', a)
      }
    }
  },
  addLastErrorEP({ commit, getters }, data) {
    commit('LAST_ERROR_EP', data)
  },
  addEPError({ commit, getters }, data) {
    commit('EP_ERROR', data)
  },
  addEPPayload({ commit, getters }, data) {
    commit('EP_PAYLOAD', data)
  },
  addErrorCode({ commit, getters }, data) {
    commit('ERROR_CODE', data)
  },
  addEPDatetime({ commit, getters }, data) {
    commit('EP_DATETIME', data)
  },
  setStaticMenuDesktopInactive({ commit }, data) {
    if (typeof data === 'boolean') {
      commit('STATIC_MENU_DESKTOP_INACTIVE', data)
    }
  },
  setActiveThemeColor({ commit }, data )  {
    commit('ACTIVE_THEME_COLOR', data)
  },
  computeAppWindowWidthHeight({ commit }) {
    var main = document.getElementById('layout-content'), compStyles = window.getComputedStyle(main), width = compStyles.getPropertyValue('width'), height = compStyles.getPropertyValue('height')

    if (width && width.length > 2) {
      width = parseFloat(width.substr(0, width.length - 2))
      commit('APP_WINDOW_WIDTH', width)
    }
    if (height && height.length > 2) {
      height = parseFloat(height.substr(0, height.length - 2))
      commit('APP_WINDOW_HEIGHT', height)
    }
  },
  setAppWindowWidth({ commit }, value) {
    if (typeof value === 'number') {
      commit('APP_WINDOW_WIDTH', value)
    }
  },
  setAppWindowHeight({ commit }, value) {
    if (typeof value === 'number') {
      commit('APP_WINDOW_HEIGHT', value)
    }
  },
  setVideosData({ commit }, value) {
    if (value && Array.isArray(value)) {
      commit('VIDEOS_DATA', value)
    }
  },
  setRequestingVideos({ commit }, value) {
    if (typeof value === 'boolean') {
      commit('REQUESTING_VIDEOS', value)
    }
  }
}

export default actions